const landlineVsMobileSecurity = {
  slug: 'landline-vs-mobile-security',
  title: 'Landline vs mobile phone security risks',
  description:
    'Compare scam and fraud risks on Australian landlines and mobiles — spoofing, SIM swap, and what to watch for on each.',
  category: 'guides',
  guideType: 'comparison',
  readMinutes: 5,
  partnerTip: 'none',
  relatedSlugs: ['smishing', 'two-factor-authentication'],
  sections: [
    {
      type: 'heading',
      level: 2,
      text: 'Landline risks',
    },
    {
      type: 'list',
      items: [
        'Often used to target older households with impersonation scams',
        'Easier for households to share one number — less personal device control',
        'Limited built-in spam filtering compared to modern mobiles',
      ],
    },
    {
      type: 'heading',
      level: 2,
      text: 'Mobile risks',
    },
    {
      type: 'list',
      items: [
        'Smishing (SMS links) and malicious apps',
        'SIM-swap attacks targeting SMS two-factor codes',
        'More personal data on device if remote access is granted',
      ],
    },
    {
      type: 'heading',
      level: 2,
      text: 'Shared scam tactics',
    },
    {
      type: 'paragraph',
      text: 'Both can receive spoofed caller ID, robocalls, and impersonation. Verification steps are the same: hang up, call back on official numbers, never share codes.',
    },
    {
      type: 'link',
      to: '/learn/two-factor-authentication',
      label: 'Use app-based 2FA on important accounts',
    },
  ],
};

export default landlineVsMobileSecurity;
